import { defineComponent as _defineComponent } from 'vue'
import { useLanguageStore } from '@/helpers/composables/useStores';
import { WebLocale } from '@/enums/web-locale';
import { getVm } from '@/helpers/vm-helper';
import {
	reverseCategoryQueryMapping,
	reverseObjectTypeQueryMapping,
} from '@/components/details/streaming-chart/streaming-chart-config';
import { PopularityRankTypes, StreamingChartObjectType } from '@/@types/graphql-types';
export interface FilterSelectItem {
	value: string | null;
	name: string;
	icon?: string;
}

interface FilterSelectProps {
	items: FilterSelectItem[];
	filterType: string;
	icon?: string;
	webLocale?: WebLocale;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FilterSelect',
  props: {
    items: null,
    filterType: null,
    icon: null,
    webLocale: null
  },
  setup(__props: any) {

const props = __props as { items: FilterSelectItem[], filterType: string, icon?: string, webLocale?: WebLocale }

const { webLocale } = useLanguageStore();
const vm = getVm();



const preSelectedCondition = (item: FilterSelectItem) => {
	if (props.filterType === 'objectType' && vm.$route.query.t) {
		return (
			item.value ===
			(reverseObjectTypeQueryMapping[
				vm.$route.query.t as keyof typeof reverseObjectTypeQueryMapping
			] as StreamingChartObjectType)
		);
	}

	if (props.filterType === 'category' && vm.$route.query.ct) {
		return (
			item.value ===
			(reverseCategoryQueryMapping[
				vm.$route.query.ct as keyof typeof reverseCategoryQueryMapping
			] as PopularityRankTypes)
		);
	}

	if (props.filterType === 'country')
		return (
			item.value ===
			(vm.$route.query.c === 'global'
				? null
				: props.webLocale?.toUpperCase() === 'UK'
				? 'GB'
				: props.webLocale?.toUpperCase())
		);

	return item.value === 'WEEKLY_POPULARITY_SAME_CONTENT_TYPE';
};

return { __sfc: true,webLocale, vm, props, preSelectedCondition }
}

})